import script from "./MostViewedCardMolecule.vue?vue&type=script&setup=true&lang=ts"
export * from "./MostViewedCardMolecule.vue?vue&type=script&setup=true&lang=ts"

import "./style.css?vue&type=style&index=0&id=b2508718&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2508718"]])

export default __exports__